;(() => {
	const mL = string => {
		const data = {
			title: {
				it: 'IMPORTANTE!',
				en: 'IMPORTANT!',
				de: 'WICHTIG!',
			},
			closeModal: {
				it: 'Chiudi modale',
				en: 'Close modal',
				de: 'Modal schließen',
			},
			contentHTML: {
				it: `<p>I tracciati Gps degli itinerari presenti in questo sito web (realizzati in formato gpx) sono stati rilevati con apposita strumentazione e/o preparati/rivisti tramite software apposito; si segnala che possono, tuttavia, contenere imprecisioni, errori, lacune, ecc.</p><p>Tutti i percorsi proposti sono stati redatti e tracciati con cura; ciononostante possono presentare sviste, sbagli o indicazioni imprecise (qualora ne notiate non esitate a comunicarcelo, scrivendo a <a href="mailto:info@asiago.it">info@asiago.it</a>).  È perciò consigliabile attrezzarsi di cartine escursionistiche apposite o Gps.</p><p>Ricordiamo che<strong> fare camminate o percorrere itinerari ed escursioni di qualsiasi tipo in montagna, a piedi o con altri mezzi, è sempre un’attività potenzialmente pericolosa</strong>. Vi raccomandiamo, quindi, la massima prudenza e <strong>decliniamo ogni responsabilità</strong> per qualsiasi incidente, danno, disguido o disavventura possa derivare agli utenti percorrendo gli itinerari proposti nel nostro sito.</p><p>Qualora vogliate inviarci proposte di integrazione, informazioni o segnalazioni in merito agli itinerari da noi presentati nel nostro sito, potete scriverci a <a href="mailto:info@webcloud.it">info@webcloud.it</a>. <strong>Suggerimenti, foto e video</strong> sono sempre ben accetti.</p><hr><p><strong>COPYRIGHT</strong></p><p><strong>Tutti i contenuti di questo sito appartengono a <a href="http://Asiago.it/Webcloud">Webcloud</a> di Andrea Vescovi</strong>, ditta proprietaria del portale <a href="http://Asiago.it">Asiago.it</a>. Per quanto riguarda gli <strong>itinerari</strong>, né è <strong>concesso l’utilizzo a titolo gratuito esclusivamente per uso personale</strong>, come ausilio durante le escursioni.</p><p>Ne sono invece <strong>vietati la riproduzione e l’uso (a scopo di lucro o meno) su altri siti web, servizi o pubblicazioni sia online che cartacee, e per ogni altro utilizzo diverso da quello personale</strong> come ausilio nelle escursioni. Per tali scopi è necessario ottenere una liberatoria scritta da parte <a href="http://Asiago.it/Webcloud">Webcloud</a> di Andrea Vescovi.</p>`,
				en: `<p>The Gps tracks of the routes on this website (made in gpx format) have been detected with special instrumentation and/or prepared/revised through special software; however, they may contain inaccuracies, errors, gaps, etc.</p><p>All the proposed routes have been carefully drawn up and plotted; however, they may present oversights, mistakes or inaccurate indications (if you notice it do not hesitate to tell us, writing to <a href="mailto:info@asiago.it">info@asiago.it).</a> &nbsp;It is therefore advisable to equip yourself with dedicated hiking maps or Gps.</p><p>Remember that<strong> walking or hiking any kind in the mountains, on foot or by other means is always a potentially dangerous activity.</strong> We recommend, therefore, the utmost prudence and <strong>we decline any responsibility</strong> for any accident, damage, misadventure or misadventure may result from users following the routes proposed on our site.</p><p>If you would like to send us proposals for integration, information or reports about the itineraries presented by us on our website, you can write to us <a href="mailto:info@webcloud.it">at info@webcloud.it.</a> <strong>Suggestions, photos and videos</strong> are always welcome.</p><hr/><p><strong>Copyright</strong></p><p><strong>All the contents of this site belong to <a href="http://Asiago.it/Webcloud">Webcloud</a> by Andrea Vescovi,</strong>company that owns the <a href="http://Asiago.it">portal Asiago.it.</a> As for the <strong>itineraries,</strong>neither is <strong>allowed to be used free of charge exclusively for personal use,</strong>as an aid during excursions.</p><p>On the other hand, it is <strong>forbidden to reproduce and use (for profit or not) on other websites, services or publications both online and in print, and for any other use other than the personal one</strong> as an aid in excursions. For these purposes it is necessary to obtain a written release from <a href="http://Asiago.it/Webcloud">Webcloud</a> of Andrea Bishops.</p>`,
				de: `<p>Die Gps-Spuren der Routen auf dieser Website (im gpx-Format) wurden mit spezieller Instrumentierung erkannt und/oder durch spezielle Software vorbereitet/&uuml;berarbeitet; Sie k&ouml;nnen jedoch Ungenauigkeiten, Fehler, L&uuml;cken usw. enthalten.</p><p>Alle vorgeschlagenen Routen wurden sorgf&auml;ltig ausgearbeitet und aufgeplottet; sie k&ouml;nnen jedoch Versehen, Fehler oder ungenaue Angaben enthalten (wenn Sie bemerken, dass es nicht z&ouml;gern, uns zu sagen, schreiben <a href="mailto:info@asiago.it">Sie an info@asiago.it).</a> &nbsp;Es ist daher ratsam, sich mit speziellen Wanderkarten oder Gps auszustatten.</p><p>Denken Sie daran, dass<strong> Wandern oder Wandern jede Art von Art in den Bergen, zu Fu&szlig; oder mit anderen Mitteln ist immer eine potenziell gef&auml;hrliche Aktivit&auml;t.</strong> Wir empfehlen daher &auml;u&szlig;erste Vorsicht und <strong>lehnen jegliche Verantwortung</strong> f&uuml;r Unf&auml;lle, Sch&auml;den, Missgeschicke oder Missgeschicke ab, die von Benutzern sein k&ouml;nnen, die die auf unserer Website vorgeschlagenen Routen befolgen.</p><p>Wenn Sie uns Integrationsvorschl&auml;ge, Informationen oder Berichte &uuml;ber die von uns auf unserer Website pr&auml;sentierten Reiserouten zusenden m&ouml;chten, k&ouml;nnen Sie uns <a href="mailto:info@webcloud.it">bitte info@webcloud.it.</a> <strong>Anregungen, Fotos und Videos</strong> sind immer willkommen.</p><hr/><p><strong>Copyright</strong></p><p><strong>Alle Inhalte dieser Website geh&ouml;ren <a href="http://Asiago.it/Webcloud">Webcloud</a> von Andrea Vescovi,</strong>einer Firma, der das <a href="http://Asiago.it">Portal geh&ouml;rt Asiago.it.</a> Was die <strong>Routen betrifft,</strong>so ist keine der beiden kostenlosen <strong>Nutzungen ausschlie&szlig;lich f&uuml;r den pers&ouml;nlichen Gebrauch,</strong>als Hilfe bei Ausfl&uuml;gen gestattet.</p><p>Andererseits ist es verboten, andere <strong>Websites, Dienstleistungen oder Ver&ouml;ffentlichungen online und in gedruckter Form zu reproduzieren und zu verwenden (gewinnbringend oder nicht) und f&uuml;r jede andere Verwendung als die pers&ouml;nliche</strong> als Hilfe bei Ausfl&uuml;gen. Zu diesem Zweck ist es notwendig, eine schriftliche Ver&ouml;ffentlichung von <a href="http://Asiago.it/Webcloud">Webcloud</a> von Andrea Bishops zu erhalten.</p>`,
			},
			btnPrimary: {
				it: 'Accetta e Scarica',
				en: 'Accept and Download',
				de: 'Akzeptieren und herunterladen',
			},
			btnSecondary: {
				it: 'Annulla',
				en: 'Cancel',
				de: 'Stornieren',
			},
			btnSecondaryAriaLabel: {
				it: 'Chiudi la finestra di dialogo',
				en: 'Close the dialog',
				de: 'Schließen Sie den Dialog',
			},
			btnReadmore: {
				it: 'Leggi tutto',
				en: 'Read everything',
				de: 'Lesen Sie alles',
			},
			downloadText: {
				it: 'Scarica la traccia GPS',
				en: 'Download the GPS track',
				de: 'Laden Sie den GPS-Track herunter',
			},
		}

		return data?.[string] ? data[string][WC.lang.substr(0, 2)] : '???'
	}

	const processContentReadmore = html => {
		if (!html.includes('<!--READMORE-->')) {
			return html
		}
		const texts = html.split('<!--READMORE-->')
		const intro = texts[0]
		const more = texts[1]

		let newHtml = `
			<div class="modal-content-intro">${intro}</div>
			<a class="modal-content-readmore" href="javascript:void(0)">${mL(
				'btnReadmore'
			)}</a>
			<div class="modal-content-more" style="display: none">${more}</div>
		`

		return newHtml
	}

	const processModal = modalId => {
		const modal = document.querySelector(`#${modalId}`)

		modal.querySelector(`#${modalId}__title`).textContent = mL('title')
		modal
			.querySelector(`.modal__close`)
			.setAttribute('aria-label', mL('closeModal'))
		modal.querySelector(
			`#${modalId}__content`
		).innerHTML = processContentReadmore(mL('contentHTML'))
		modal.querySelector('.modal__btn-primary').textContent = mL(
			'btnPrimary'
		)
		modal.querySelector('.modal__btn-secondary').textContent = mL(
			'btnSecondary'
		)
		modal
			.querySelector('.modal__btn-secondary')
			.setAttribute('aria-label', mL('btnSecondaryAriaLabel'))

		// Events
		const readmore = modal.querySelector(
			`#${modalId}__content .modal-content-readmore`
		)

		if (readmore) {
			readmore.addEventListener('click', e => {
				e.preventDefault()
				e.target.parentNode.querySelector(
					'.modal-content-more'
				).style.display = 'block'
				e.target.remove()
			})
		}
	}

	const slugify = (text, separator) => {
		text = text.toString().toLowerCase().trim()

		const sets = [
			{to: 'a', from: '[ÀÁÂÃÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]'},
			{to: 'ae', from: '[Ä]'},
			{to: 'c', from: '[ÇĆĈČ]'},
			{to: 'd', from: '[ÐĎĐÞ]'},
			{to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'},
			{to: 'g', from: '[ĜĞĢǴ]'},
			{to: 'h', from: '[ĤḦ]'},
			{to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]'},
			{to: 'j', from: '[Ĵ]'},
			{to: 'ij', from: '[Ĳ]'},
			{to: 'k', from: '[Ķ]'},
			{to: 'l', from: '[ĹĻĽŁ]'},
			{to: 'm', from: '[Ḿ]'},
			{to: 'n', from: '[ÑŃŅŇ]'},
			{to: 'o', from: '[ÒÓÔÕØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]'},
			{to: 'oe', from: '[ŒÖ]'},
			{to: 'p', from: '[ṕ]'},
			{to: 'r', from: '[ŔŖŘ]'},
			{to: 's', from: '[ŚŜŞŠ]'},
			{to: 'ss', from: '[ß]'},
			{to: 't', from: '[ŢŤ]'},
			{to: 'u', from: '[ÙÚÛŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'},
			{to: 'ue', from: '[Ü]'},
			{to: 'w', from: '[ẂŴẀẄ]'},
			{to: 'x', from: '[ẍ]'},
			{to: 'y', from: '[ÝŶŸỲỴỶỸ]'},
			{to: 'z', from: '[ŹŻŽ]'},
			{to: '-', from: "[·/_,:;']"},
		]

		sets.forEach(set => {
			text = text.replace(new RegExp(set.from, 'gi'), set.to)
		})

		text = text
			.toString()
			.toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w\-]+/g, '') // Remove all non-word chars
			.replace(/\--+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') // Trim - from end of text

		if (typeof separator !== 'undefined' && separator !== '-') {
			text = text.replace(/-/g, separator)
		}

		return text
	}

	const processDownload = () => {
		const title = document.querySelector('.body-page .riquadro #content h1')
			.textContent

		const node = document.createElement('a')
		node.href = `/download/trailsgpx/${WC.idArticolo}.gpx`
		node.setAttribute('download', `${slugify(title)}.gpx`)

		document.querySelector('body').appendChild(node)
		node.click()
		node.remove()
	}

	const displayModal = modalId => {
		MicroModal.show(modalId)

		document
			.querySelector(`#${modalId}`)
			.querySelector('.modal__btn-primary')
			.addEventListener('click', e => {
				// localStorage.setItem('trailsGpxAccepted', new Date().getTime())
				processDownload()
				MicroModal.close(modalId)
			})
	}

	const placeTrigger = (target, modalId) => {
		processModal(modalId)

		// Creating
		const node = document.createElement('div')
		node.classList.add('trailsgpxdownload__trigger')

		node.innerHTML = `<a class="trailsgpx-download-link" href="javascript:void(0)">${mL(
			'downloadText'
		)}</a>`

		// Placing
		target.parentNode.insertBefore(node, target.nextSibling)

		// Events
		node.addEventListener('click', () => {
			displayModal(modalId)
		})

		return true
	}

	// Running
	const wantedArticles = [14190]
	// const target = document.querySelector(
	// 	'.escursioni > .escursioni-title-gray'
	// )
	const target = document.querySelector('.iframe-container-trailquote')

	if (
		WC?.idArticolo &&
		wantedArticles.indexOf(WC.idArticolo) > -1 &&
		target
	) {
		const modalId = 'modal-trailsgpx'
		placeTrigger(target, modalId)
	}
})()
